import React from 'react';
import { Wrapper } from '../../components_mobile/css_global/utils.css';
import { AboutUsBody, AboutUsHeader, AboutUsSubtitle } from './styled';
import VerticalSpacer from '../VerticalSpacer';

const AboutUsWelcome = () => (
  <div>
    <AboutUsHeader>Welcome to italist</AboutUsHeader>
    <VerticalSpacer height="30px" />
    <AboutUsSubtitle>
      Expertly-curated luxury, imported from Italy at the best price, and delivered to your doorstep.
    </AboutUsSubtitle>

    <VerticalSpacer height="20px" />
    <AboutUsBody>
      italist is the first platform to offer direct-to-consumer imports of luxury goods exclusively from Italy. Through
      italist, customers can purchase brand-new, genuine, in-season fashion and accessories from our partner boutiques
      in Italy. The same high-quality products you’d find on other sites are available at a lower retail price through
      our partner boutiques—up to 30% less—so italist always provides the best value.
      <VerticalSpacer height="20px" />
      <Wrapper textAlign="center">
        How do we do it?
        <br />
        Here’s a quick look at how #italistdoesitbetter.
      </Wrapper>
    </AboutUsBody>
  </div>
);

export default AboutUsWelcome;
